/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import ictLogo from '../../assets/images/ICT-Logo-V4-1-1 1 (1).png';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';
import { Sidebar } from 'primereact/sidebar';
import AddEditRoutes from './AddEditRoutes';
import { handleGetRequest } from '../../services/GetTemplate';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import './RoutesManagement.css';
import DeleteIcon from '../../assets/icons/delete.svg';
import { handleDeleteRequest } from '../../services/DeleteTemplate';
import SuccessLoader from '../../components/SuccessLoader';
import { handlePostRequest } from '../../services/PostTemplate';
import { FilterMatchMode } from 'primereact/api';

function RoutesManagement() {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editAble, setEditAble] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [roleIDOptions, setroleIDOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="Global__Header">
                <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search..." />
                </span>
            </div>
        );
    };

    const header = () => renderHeader();

    const dispatch = useDispatch();
    const menuRefs = useRef(new Map());

    const handleDelete = async (row) => {
        setIsLoading(true);
        try {
            const response = await dispatch(handleDeleteRequest(`/api/route/${row.id}`, true, true));
            if (response?.success) {
                setDeleteDialogVisible(false);
                setUserToDelete(null);
                setShowSuccess(true);

                fetchUsersData(page);

                setTimeout(() => {
                    setShowSuccess(false);
                }, 2000);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchUsersData = async (pageNumber = 1) => {
        setLoading(true);
        try {
            // setLoading(true);
            const data = {
                pageNumber: pageNumber,
                size: rows
            }
            const response = await dispatch(handlePostRequest(data, `/api/route/get`, false, false))

            if (response?.success) {
                setTableData(response?.data || []);
                setTotalRecords(response?.data[0]?.totalRecords || 50);

                // setShowSuccess(true);
                setTimeout(() => {
                    setShowSuccess(false);
                }, 2000);
            }
        } catch (error) {
            console.error('Error fetching users data:', error);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        setFirst(event.first);
        setRows(event.rows);
        setPage(newPage);
        fetchUsersData(newPage);
    };

    useEffect(() => {
        fetchUsersData(page);
    }, []);

    const actionBodyTemplate = (rowData) => {
        const handleEdit = (row) => {
            setSidebarVisible(true);
            setIsEditing(true);
            setEditData(row);
            setEditAble(true);
        };

        const confirmDelete = (row) => {
            setUserToDelete(row);
            setDeleteDialogVisible(true);
        };

        const items = [
            {
                label: 'Edit',
                icon: 'pi pi-pencil',
                className: ' custom-edit',
                command: () => handleEdit(rowData)
            },
            {
                label: 'Delete',
                icon: 'pi pi-trash',
                className: ' custom-delete',
                command: () => confirmDelete(rowData)
            }
        ];

        // Get or create a unique menu reference for this row
        if (!menuRefs.current.has(rowData.id)) {
            menuRefs.current.set(rowData.id, React.createRef());
        }
        const rowMenuRef = menuRefs.current.get(rowData.id);

        return (
            <div>
                <Menu model={items} popup ref={rowMenuRef} />
                <Button
                    icon="pi pi-ellipsis-h"
                    className="p-button p-0 m-0 bg-white border-none shadow-none hover:bg-gray-100 custom-icon-black"
                    style={{ boxShadow: 'none' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        rowMenuRef.current.toggle(e);
                    }}
                />
            </div>
        );
    };

    const rowClassName = (rowData) => {
        return 'dataTableRow';
    };

    const template1 = {
        layout: 'CurrentPageReport',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'left', fontSize: '12px', fontWeight: '400' }}>
                    Showing{' '}
                    <span style={{ fontWeight: '700' }}>
                        {options.first} - {Math.min(options.first + options.rows - 1, options.totalRecords)}
                    </span>{' '}
                    from <span style={{ fontWeight: '700' }}>{options.totalRecords}</span> data
                </span>
            );
        }
    };

    const template2 = {
        layout: 'PrevPageLink PageLinks NextPageLink',
        PrevPageLink: (options) => {
            return <Button icon="pi pi-chevron-left" className="p-button prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        },
        PageLinks: (options) => {
            const isActive = options.currentPage === options.page;
            return (
                <button
                    type="button"
                    className={`mx-1 px-4 py-2 ${isActive ? 'isActivePage' : 'notActivePage'}`}
                    onClick={options.onClick}
                    style={{
                        width: '40.08px',
                        height: '40.08px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        margin: '2px',
                        border: 'none',
                        boxShadow: isActive ? '0px 7px 16px 0px #00000024' : 'none'
                    }}
                >
                    {options.page + 1}
                </button>
            );
        },
        NextPageLink: (options) => {
            return <Button icon="pi pi-chevron-right" className="p-button-text prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        }
    };

    const onHideSidebar = () => {
        console.log('calleeeddddd')
        setSidebarVisible(false);
        setIsEditing(false);
        setEditData(null);
        setEditAble(false);
    };

    return (
        <>
            {/* {showSuccess && <SuccessLoader />} */}
            <ConfirmDialog
                visible={deleteDialogVisible}
                onHide={() => setDeleteDialogVisible(false)}
                message="On clicking this, user details will be removed from the system. Proceed further?"
                contentClassName="content-className"
                header="Delete User"
                headerClassName="text-black"
                icon={<img src={DeleteIcon} alt="Delete" />}
                acceptLabel="Sure"
                rejectLabel="Close"
                acceptClassName="accept-button"
                rejectClassName="reject-button"
                className="custom-confirm-dialog"
                accept={() => handleDelete(userToDelete)}
            />
            <div className="grid">
                <div className="col-12 flex flex-column">
                    <Sidebar
                        className="p-sidebar-md"
                        visible={sidebarVisible}
                        position="right"
                        onHide={onHideSidebar}
                        style={{ width: '30rem' }}
                        pt={{
                            header: { className: 'border-bottom-1' },
                            content: { className: 'p-0', style: { overflow: 'hidden' } }
                        }}
                        showCloseIcon={false}
                    >
                        <AddEditRoutes
                            onHideSidebar={onHideSidebar}
                            isEditing={isEditing}
                            editData={editData}
                            editAble={editAble}
                            fetchUsersData={fetchUsersData}
                        />
                    </Sidebar>
                    <div className="flex justify-content-between items-center">
                        <h2 className="text-lg font-semibold">Route Management</h2>
                        <div className="flex items-center gap-2">
                            {/* <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="p-inputtext-sm rounded-input" />
                            </span> */}
                            <Button
                                label="Add New"
                                icon="pi pi-plus"
                                className="px-4 py-2 font-semibold"
                                style={{ backgroundColor: '#FF556A', border: 'none', borderRadius: '10px', width: '140px' }}
                                onClick={() => {
                                    setSidebarVisible(true);
                                    setIsEditing(false);
                                    setEditData(null);
                                    setEditAble(false);
                                }}
                            />
                        </div>
                    </div>
                    <div className="card mt-3">
                        <DataTable
                            globalFilterFields={['routeNumber', 'routeFrom', 'routeTo', 'vehicles']}
                            filters={filters}
                            header={header}
                            value={tableData}
                            className="datatable-responsive shadow-md rounded-xl"
                            responsiveLayout="scroll"
                            loading={loading}
                            scrollable
                            style={{ minHeight: '65vh' }}
                            stickyHeader
                            emptyMessage={
                                <div className="w-full text-center">
                                    No results found
                                </div>
                            }
                        >
                            <Column
                                field="routeNumber"
                                header="Route Number"
                                body={(rowData) => (
                                    <div>
                                        <span>{rowData.routeNumber}</span>
                                    </div>
                                )}
                            />
                            <Column
                                field="routeFrom"
                                header="Route From"
                                body={(rowData) => (
                                    <div>
                                        <span>{rowData.routeFrom}</span>
                                    </div>
                                )}
                            />
                            <Column
                                field="routeTo"
                                header="Route To"
                                body={(rowData) => (
                                    <div>
                                        <span>{rowData.routeTo}</span>
                                    </div>
                                )}
                            />
                            <Column
                                field="vehicles"
                                header="Vehicles"
                                body={(rowData) => (
                                    <div>
                                        <span>{rowData.vehicles}</span>
                                    </div>
                                )}
                            />
                            <Column
                                field="distanceInKm"
                                header="Distance In Km"
                                body={(rowData) => (
                                    <div>
                                        <span>{rowData.distanceInKm}</span>
                                    </div>
                                )}
                            />
                            <Column
                                field="fare"
                                header="Fare"
                                body={(rowData) => (
                                    <div>
                                        <span>{rowData.fare}</span>
                                    </div>
                                )}
                            />

                            <Column
                                field="status"
                                header="Status"
                                body={(rowData) => (
                                    <div
                                        className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${rowData.isActive === true ? 'bg-[#E6F4EA] text-[#3A974C] Active-column' : rowData.isActive === false ? 'bg-[#FFEFE9] text-[#FF8F6B] Inactive-column' : ''
                                            }`}
                                    >
                                        {rowData.isActive === true ? 'Active' : rowData.isActive === false ? 'Inactive' : ''}
                                    </div>
                                )}
                            />
                            <Column body={(rowData) => actionBodyTemplate(rowData)} />
                        </DataTable>
                        <div className="flex justify-content-between mb-3 sticky" style={{ borderTop: '1px solid #efefef', marginTop: '90px' }}>
                            <Paginator template={template1} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
                            <Paginator template={template2} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} rowsPerPageOptions={[10, 25, 50]} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RoutesManagement;
